export var SocialMediaEnum;
(function (SocialMediaEnum) {
    SocialMediaEnum["INSTAGRAM"] = "Instagram";
    SocialMediaEnum["X"] = "X";
    SocialMediaEnum["YOUTUBE"] = "YouTube";
    SocialMediaEnum["TIKTOK"] = "TikTok";
    SocialMediaEnum["FACEBOOK"] = "Facebook";
    SocialMediaEnum["LINKEDIN"] = "LinkedIn";
    SocialMediaEnum["WHATSAPP"] = "WhatsApp";
    SocialMediaEnum["SNAPCHAT"] = "SnapChat";
    SocialMediaEnum["DISCORD"] = "Discord";
})(SocialMediaEnum || (SocialMediaEnum = {}));
